var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.197509 7.44439L14.4949 0.0407791C14.6227 -0.025398 14.7744 -0.00997634 14.8816 0.0793749C14.9881 0.168517 15.0271 0.315014 14.9807 0.449414L9.70119 15.7536C9.65322 15.8926 9.52398 15.9907 9.3764 15.9993C9.33438 16.002 9.29293 15.9967 9.2544 15.9849C9.15943 15.9559 9.08072 15.8863 9.0429 15.7917L6.69386 9.35797L0.236545 8.0844C0.102418 8.04346 0.00890609 7.92518 0.000685845 7.78516C-0.00817731 7.6449 0.0694863 7.51123 0.197509 7.44439Z",
    fill: "#C5C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/mapIcon.2758b485a76c13e45e18131fd01544fc.svg";
export { ForwardRef as ReactComponent };